import { takeLatest, call, put } from 'redux-saga/effects'
import {
    performanceAddGoalCommentAPI, performanceGoalDetailAPI,
    performanceGoalListAPI, performanceNewGoalAPI, performanceNewRequestAPI,
    performanceNewReviewAPI, performanceRequestListAPI, performanceReviewListAPI,
    performanceUpdateGoalAPI
} from '../api-requests/performance';
import {
    peformanceAddGoalCommentRequestError, peformanceAddGoalCommentRequestSuccess, peformanceGoalDetailsRequestError,
    peformanceGoalDetailsRequestSuccess, peformanceGoalListRequestError, peformanceGoalListRequestSuccess,
    peformanceNewGoalRequestError, peformanceNewGoalRequestSuccess, peformanceNewRequestError,
    peformanceNewRequestSuccess, peformanceNewReviewRequestError, peformanceNewReviewRequestSuccess,
    peformanceRequestListRequestError, peformanceRequestListRequestSuccess,
    peformanceReviewListRequestError, peformanceReviewListRequestSuccess, peformanceUpdateGoalRequestError,
    peformanceUpdateGoalRequestSuccess
} from './peformance.action';
import { PerformanceActionTypes } from './performance.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';
import { APP_CONSTANTS } from '../../utils/AppConstants';

function* handlePeformanceReviewListRequest({ payload }) {
    try {
        const response = yield call(performanceReviewListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(peformanceReviewListRequestSuccess(decryptedData))
            } else {
                yield put(peformanceReviewListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PerformanceActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(peformanceReviewListRequestError(error.response.data))
        }
    }
}

export function* performanceReviewListReq() {
    yield takeLatest(PerformanceActionTypes.PEFORMANCE_REVIEW_LIST_REQUEST, handlePeformanceReviewListRequest)
}

function* handlePeformanceNewReviewRequest({ payload }) {
    try {
        const response = yield call(performanceNewReviewAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(peformanceNewReviewRequestSuccess(decryptedData))
            } else {
                yield put(peformanceNewReviewRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PerformanceActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(peformanceNewReviewRequestError(error.response.data))
        }
    }
}

export function* performanceNewReviewReq() {
    yield takeLatest(PerformanceActionTypes.PERFORMANCE_NEW_REVIEW_REQUEST, handlePeformanceNewReviewRequest)
}

function* handlePeformanceRequestList({ payload }) {
    try {
        const response = yield call(performanceRequestListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(peformanceRequestListRequestSuccess(decryptedData))
            } else {
                yield put(peformanceRequestListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PerformanceActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(peformanceRequestListRequestError(error.response.data))
        }
    }
}

export function* performanceRequestListReq() {
    yield takeLatest(PerformanceActionTypes.PEFORMANCE_REQUEST_LIST_REQUEST, handlePeformanceRequestList)
}

function* handlePeformanceNewRequest({ payload }) {
    try {
        const response = yield call(performanceNewRequestAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(peformanceNewRequestSuccess(decryptedData))
            } else {
                yield put(peformanceNewRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PerformanceActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(peformanceNewRequestError(error.response.data))
        }
    }
}

export function* performanceNewRequestReq() {
    yield takeLatest(PerformanceActionTypes.PEFORMANCE_NEW_REQUEST, handlePeformanceNewRequest)
}

function* handlePeformanceUpdateGoalRequest({ payload }) {
    try {
        const response = yield call(performanceUpdateGoalAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(peformanceUpdateGoalRequestSuccess(decryptedData))
            } else {
                yield put(peformanceUpdateGoalRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PerformanceActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(peformanceUpdateGoalRequestError(error.response.data))
        }
    }
}

export function* performanceUpdateGoalReq() {
    yield takeLatest(PerformanceActionTypes.PEFORMANCE_UPDATE_GOAL_REQUEST, handlePeformanceUpdateGoalRequest)
}

function* handlePeformanceNewGoalRequest({ payload }) {
    try {
        const response = yield call(performanceNewGoalAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(peformanceNewGoalRequestSuccess(decryptedData))
            } else {
                yield put(peformanceNewGoalRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PerformanceActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(peformanceNewGoalRequestError(error.response.data))
        }
    }
}

export function* performanceNewGoalReq() {
    yield takeLatest(PerformanceActionTypes.PEFORMANCE_NEW_GOAL_REQUEST, handlePeformanceNewGoalRequest)
}

function* handlePeformanceGoalListRequest({ payload }) {
    try {
        const response = yield call(performanceGoalListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(peformanceGoalListRequestSuccess(decryptedData))
            } else {
                yield put(peformanceGoalListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PerformanceActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(peformanceGoalListRequestError(error.response.data))
        }
    }
}

export function* performanceGoalListReq() {
    yield takeLatest(PerformanceActionTypes.PEFORMANCE_GOAL_LIST_REQUEST, handlePeformanceGoalListRequest)
}

function* handlePeformanceGoalDetailRequest({ payload }) {
    try {
        const response = yield call(performanceGoalDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(peformanceGoalDetailsRequestSuccess(decryptedData))
            } else {
                yield put(peformanceGoalDetailsRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PerformanceActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(peformanceGoalDetailsRequestError(error.response.data))
        }
    }
}

export function* performanceGoalDetailsReq() {
    yield takeLatest(PerformanceActionTypes.PEFORMANCE_GOAL_DETAILS_REQUEST, handlePeformanceGoalDetailRequest)
}

function* handlePeformanceAddGoalCommentRequest({ payload }) {
    try {
        const response = yield call(performanceAddGoalCommentAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(peformanceAddGoalCommentRequestSuccess(decryptedData))
            } else {
                yield put(peformanceAddGoalCommentRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PerformanceActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(peformanceAddGoalCommentRequestError(error.response.data))
        }
    }
}

export function* performanceAddGoalCommentReq() {
    yield takeLatest(PerformanceActionTypes.PEFORMANCE_ADD_GOAL_COMMENT_REQUEST, handlePeformanceAddGoalCommentRequest)
}